import { useEffect, useContext } from 'react';
import Sidebar from './components/Sidebar/Sidebar';
import Tabs from './components/Tabs/Tabs';
import { TabContext } from './Context/TabContext';
import withRouter from '../utils/withRouter';
import './Template.css';
import { isMobile } from '../utils/isMobile';

function Template() {
  const tabContext = useContext(TabContext);

  useEffect(() => {
    tabContext.onPageLoad();
  }, []);

  return (
    <div
      style={{ marginTop: isMobile() ? '0px' : '35px' }}
      className="template"
    >
      <Sidebar />
      <Tabs />
    </div>
  );
}

export default withRouter(Template);
